export default function Logo({ onDark = true }) {
  const text = onDark ? 'text-cream' : 'text-navy';
  return (
    <a href="#top" data-testid="logo-link" className="flex items-center gap-3 group">
      <svg width="56" height="56" viewBox="0 0 48 48" aria-hidden="true" className="transition-transform duration-500 group-hover:rotate-[15deg]">
        <circle cx="24" cy="24" r="22.5" fill="none" stroke="#C5A059" strokeWidth="1" />
        <circle cx="24" cy="24" r="19" fill="none" stroke="#C5A059" strokeWidth="0.5" opacity="0.5" />
        <text x="24" y="28.5" textAnchor="middle" fontFamily="'Cormorant Garamond', Georgia, serif" fontSize="13" letterSpacing="1.5" fill="#C5A059">AGM</text>
      </svg>
      <span className="flex flex-col gap-[6px] leading-none">
        <span className={`block font-serif text-[23px] leading-none tracking-tight ${text}`}>A. G. Mangum &amp; Co.</span>
        <span className="block text-[11px] leading-none tracking-[0.35em] uppercase text-gold">Tax &amp; Advisory</span>
        <span className={`block font-serif italic font-medium text-[13px] leading-none tracking-wide ${onDark ? 'text-gold-light' : 'text-gold'}`}>Since 1966</span>
      </span>
    </a>
  );
}
